import { computed, makeObservable, observable } from 'mobx';

class LoadingStore {

    _loading = 0;

    constructor(model) {
        this.model = model;
        makeObservable(this, {
            model: false,
            loading: computed,
            _loading: observable
        })
    }

    set loading(value) {
        value ? this._loading++ : this._loading--;
    }

    get loading() {
        return this._loading > 0;
    }
}

export default LoadingStore;
